import { useFormik } from "formik";
import Modal from "global/Modal/Modal";
import SimpleButton from "global/SimpleButton/SimpleButton";
import ScanConsignments from "pages/order-receipt/view/action/consignments";
import { useState } from "react";
import { BiTrash } from "react-icons/bi";
import { addEditDataAPI } from "services/CRUDServices";
import { getDay } from "tools/functions/Methods";
import { BackToSourceColumn } from "../columns";
import { handleGlobalScan } from "pages/order-receipt/view/action/scan-utils";


function ScanWithBag({ setBarcodeLists, receiptBarcodes, date }) {
  const [bsgBarcodes, setBagBarcodes] = useState<{ serialNumber: string }[]>(
    []
  );
  const [isLoadingScan, setIsLoadingScan] = useState(false);
  const [isLoadingConfirm, setIsLoadingConfirm] = useState(false);
  const [open, setOpen] = useState(false);
  const formik = useFormik({
    enableReinitialize: true,
    initialValues: { consignmentId: "" },
    onSubmit: async () => {},
  });

  const onScan = (barcode: string) => {
    const existingIds = [...receiptBarcodes.map((i) => i.serialNumber)];

    handleGlobalScan(barcode, {
      mode: "immediate",
      existingIds,
      apiFunction: addEditDataAPI,
      apiUrl: `/consignment-api/smsSetting/v1/s0/barcodeScan`,
      apiPayload: {
        barcodeList: [barcode],
        date: date,
      },
      onApiSuccess: (newItem) => {
        const newItems = newItem.map((item) => ({
          serialNumber: item.Barcode,
          ReceiverName: item.ReceiverName,
        }));
        setBarcodeLists((prev) => [...prev, ...newItems]);
      },
      onLocalSuccess: (newItems) => {
        setBagBarcodes((prev) => [...prev, ...newItems]);
        setOpen(true);
      },
      setLoading: setIsLoadingScan,
    });
  };

  const bagbarcodesCall = async () => {
    if (bsgBarcodes.length === 0) return;
    const existingCprNumbers = bsgBarcodes.map((item) => item.serialNumber);
    try {
      setIsLoadingConfirm(true);
      const response = await addEditDataAPI(
        `/consignment-api/smsSetting/v1/s0/barcodeScan`,
        "post",
        {
          barcodeList: existingCprNumbers,
          date: date,
        }
      );
      const data = response.data.response;
      const newItems = data.map((item) => ({
        serialNumber: item.Barcode,
        ReceiverName: item.ReceiverName,
      }));
      setBarcodeLists((prev) => [...prev, ...newItems]);
      setIsLoadingConfirm(false);
      setOpen(false);
    } catch (e) {
      setIsLoadingConfirm(false);
    }
  };
  const handleDelete = (item) => {
    setBagBarcodes?.(
      bsgBarcodes.filter((b) => b.serialNumber !== item.serialNumber)
    );
  };

  return (
    <>
      <ScanConsignments
        formik={formik}
        handleScan={onScan}
        // isList
        columns={BackToSourceColumn}
        barcodelists={receiptBarcodes}
        setBarcodeLists={setBarcodeLists}
        loading={isLoadingScan}
        readOnly={!date}
      />

      <Modal
        visible={open}
        setVisible={() => {
          setOpen(!open);
          // setBarcodeLists([])
        }}
        title=""
      >
        {bsgBarcodes.map((item, index) => (
          <div className="flex items-center justify-between border-2 border-x-gray-200 my-3 rounded-lg p-3 shadow-sm">
            <div className="flex items-center gap-3">
              <span className="bg-tomato text-lightTomato rounded-full w-6 h-6 flex items-center justify-center text-sm">
                {index + 1}
              </span>
              <div className="flex flex-col">
                <span className="text-xs text-gray-500">شناسه مرسوله:</span>
                <span className="font-bold text-gray-800">
                  {item.cprNumber || item.serialNumber}
                </span>
              </div>
            </div>
            {item.baggingDate && <p>{getDay(item.baggingDate)}</p>}

            <button type="button" onClick={() => handleDelete(item)}>
              <BiTrash size={20} className="w-full h-full text-red-500" />
            </button>
          </div>
        ))}

        {bsgBarcodes.length === 0 ||
          (!isLoadingScan && (
            <SimpleButton
              loading={isLoadingConfirm}
              disabled={bsgBarcodes.length === 0 || isLoadingScan}
              handelClick={bagbarcodesCall}
              text="تایید مرسوله های کیسه"
              className="full-tomato-btn w-full my-4"
            />
          ))}
      </Modal>
    </>
  );
}

export default ScanWithBag;
